import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <defs>
      <path
        id="a"
        d="M7.92 0a7.92 7.92 0 110 15.84A7.92 7.92 0 017.92 0zm0 1.584c-.977 0-1.903.221-2.73.616l-.818 2.406-1.855.003a6.306 6.306 0 00-.933 3.311c0 .606.085 1.192.244 1.747L4.61 11.51l-.582 1.41a6.309 6.309 0 004.433 1.313l1.884-1.668.89.756a6.346 6.346 0 002.843-3.905l-1.224-2.444 1.154-.814a6.338 6.338 0 00-1.898-2.991l-2.94.001-.361-1.522a6.391 6.391 0 00-.889-.062zm-.142 3.168l2.877 2.09-1.1 3.383H6L4.9 6.843l2.878-2.091z"
      />
    </defs>
    <g fill="none">
      <g transform="rotate(45 4.518 31.086)">
        <mask id="b" fill="#fff">
          <use href="#a" />
        </mask>
        <use fill="#FFC100" href="#a" />
        <g fill="#051045" mask="url(#b)">
          <path d="M-.88-.88h17.6v17.6H-.88z" />
        </g>
      </g>
      <g fill="#051045">
        <path d="M12.642 29.77a1.054 1.054 0 01-1.568-1.4l.104-.116 3.35-3.235a1.054 1.054 0 011.567 1.4l-.104.116-3.35 3.235zM11.369 24.679a1.054 1.054 0 01-1.568-1.4l.104-.116 3.35-3.235a1.054 1.054 0 011.568 1.4l-.104.116-3.35 3.235zM17.733 31.043a1.054 1.054 0 01-1.568-1.4l.104-.116 3.35-3.235a1.054 1.054 0 011.568 1.4l-.105.116-3.35 3.235z" />
      </g>
    </g>
  </svg>
);

const IconAttemptsTotal = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconAttemptsTotal;
